import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ce04b1b")

_pushScopeId("data-v-0ce04b1b")
const _hoisted_1 = { class: "jb-wrap" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "jb-header" }, [
  /*#__PURE__*/_createVNode("div", null, "作业信息")
], -1)
const _hoisted_3 = { class: "jb-body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_Editor = _resolveComponent("Editor")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      spinning: _ctx.jobBasicInfo.saving.value||_ctx.jobBasicInfo.quering.value
    }, {
      default: _withId(() => [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_a_form, {
            "label-col": _ctx.labelCol,
            "wrapper-col": _ctx.wrapperCol,
            rules: _ctx.jobBasicInfo.rules
          }, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, { label: "作业名称" }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.jobBasicInfo.formState.jobName,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.jobBasicInfo.formState.jobName = $event)),
                    maxlength: 12,
                    placeholder: "请输入12字以内信息"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "知识体系" }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.jobBasicInfo.formState.jobKnowledge,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.jobBasicInfo.formState.jobKnowledge = $event)),
                    maxlength: 12,
                    placeholder: "请输入12字以内信息"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "案例详情" }, {
                default: _withId(() => [
                  _createVNode(_component_Editor, {
                    onMounted: _cache[3] || (_cache[3] = ($event: any) => (_ctx.jobBasicInfoController.handleMounted($event))),
                    modelValue: _ctx.jobBasicInfo.formState.jobInfomation,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.jobBasicInfo.formState.jobInfomation = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["label-col", "wrapper-col", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
})